/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { JobScheduleDto } from './JobScheduleDto';
import {
    JobScheduleDtoFromJSON,
    JobScheduleDtoFromJSONTyped,
    JobScheduleDtoToJSON,
} from './JobScheduleDto';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';
import type { TaskInJobDto } from './TaskInJobDto';
import {
    TaskInJobDtoFromJSON,
    TaskInJobDtoFromJSONTyped,
    TaskInJobDtoToJSON,
} from './TaskInJobDto';

/**
 * 
 * @export
 * @interface CreateOrUpdateJobConfigurationDto
 */
export interface CreateOrUpdateJobConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    protocols?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    assignedUsers?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    assignedRoles?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {Array<TaskInJobDto>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    tasks?: Array<TaskInJobDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    reviewUsers?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    reviewRoles?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {JobScheduleDto}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    schedule?: JobScheduleDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateJobConfigurationDto
     */
    $type?: CreateOrUpdateJobConfigurationDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateJobConfigurationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoCreateOrUpdateJobConfigurationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.CreateOrUpdateJobConfigurationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateJobConfigurationDtoTypeEnum = typeof CreateOrUpdateJobConfigurationDtoTypeEnum[keyof typeof CreateOrUpdateJobConfigurationDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateJobConfigurationDto interface.
 */
export function instanceOfCreateOrUpdateJobConfigurationDto(value?: unknown): value is CreateOrUpdateJobConfigurationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateJobConfigurationDtoTypeEnum)[0];
}

export function CreateOrUpdateJobConfigurationDtoFromJSON(json: any): CreateOrUpdateJobConfigurationDto {
    return CreateOrUpdateJobConfigurationDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateJobConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateJobConfigurationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'protocols': !exists(json, 'protocols') ? undefined : (json['protocols'] === null ? null : (json['protocols'] as Array<any>).map(ProtocolDtoFromJSON)),
        'assignedUsers': !exists(json, 'assignedUsers') ? undefined : json['assignedUsers'],
        'assignedRoles': !exists(json, 'assignedRoles') ? undefined : json['assignedRoles'],
        'targetSystemId': !exists(json, 'targetSystemId') ? undefined : json['targetSystemId'],
        'tasks': !exists(json, 'tasks') ? undefined : (json['tasks'] === null ? null : (json['tasks'] as Array<any>).map(TaskInJobDtoFromJSON)),
        'reviewRequired': !exists(json, 'reviewRequired') ? undefined : json['reviewRequired'],
        'reviewUsers': !exists(json, 'reviewUsers') ? undefined : json['reviewUsers'],
        'reviewRoles': !exists(json, 'reviewRoles') ? undefined : json['reviewRoles'],
        'autoApprove': !exists(json, 'autoApprove') ? undefined : json['autoApprove'],
        'schedule': !exists(json, 'schedule') ? undefined : JobScheduleDtoFromJSON(json['schedule']),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdateJobConfigurationDtoToJSON(value?: CreateOrUpdateJobConfigurationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'protocols': value.protocols === undefined ? undefined : (value.protocols === null ? null : (value.protocols as Array<any>).map(ProtocolDtoToJSON)),
        'assignedUsers': value.assignedUsers,
        'assignedRoles': value.assignedRoles,
        'targetSystemId': value.targetSystemId,
        'tasks': value.tasks === undefined ? undefined : (value.tasks === null ? null : (value.tasks as Array<any>).map(TaskInJobDtoToJSON)),
        'reviewRequired': value.reviewRequired,
        'reviewUsers': value.reviewUsers,
        'reviewRoles': value.reviewRoles,
        'autoApprove': value.autoApprove,
        'schedule': JobScheduleDtoToJSON(value.schedule),
        'isAvailable': value.isAvailable,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value.$type,
    });
}

